<div class="container animated fadeIn">
    <div class="row">
        <div class="col-12 center-container">
            <h3 class="fw-sbold fs-35 fadeTitle mb-3">¡Hola, bienvenido a <strong>Monific</strong>!<br> Nos da gusto que estes aquí</h3>

            <p class="fw-light fs-18 mt-4 mb-3 fadeSubTitle">Antes de iniciar, nos gustaria que nos cuentas un poco<span class="fw-auto"> acerca de ti </span></p>

            <form [formGroup]="firstFormDev" class="col-12 col-sm-9 col-md-8 col-lg-9 col-xl-6 my-4 fadeForm">
                <mnf-input-form formControlName="name" label="Nombre(s)" placeholder="JUAN JESUS" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                <mnf-input-form formControlName="fatherSurname" label="Apellido Paterno" placeholder="MARTINEZ" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                <mnf-input-form formControlName="motherSurname" label="Apellido Materno" placeholder="MORALES" errMsg="Debe estar lleno éste campo"></mnf-input-form>

                <mnf-input-form formControlName="phone" label="Teléfono de contacto" placeholder="55 01 02 03 04" errMsg="Debe estar lleno éste campo"></mnf-input-form>

                <div class="firstContainer">
                    <div class="row">
                        <div class="d-block m-auto d-md-flex justify-content-md-around">
                            <div class="mb-3 mt-4 col-12 m-auto col-md-12">
                                <div class="d-lfex justify-content-between w-100" *ngIf="brochureFile">
                                    <div class="cl-primary">
                                        <p class="me-3 mb-1 cl-primary"> Brochure subido: </p>
                                        <p class=""><strong>{{ brochureFile }}</strong></p>
                                    </div>
                                    <fa-icon [icon]="iconReUpload" title="Subir otro archivo" class="cr-pointer cl-primary my-auto"
                                        (click)="brochureDefined = brochureFile; brochureFile = undefined">
                                    </fa-icon>
                                </div>
                                <file-pond #pondBrochure [options]="brochureOptions" [files]="brochureFiles" (onaddfile)="pondHandleAddFile($event, 'brochure')"
                                    (onremovefile)="deleteFile('brochure')" *ngIf="!brochureFile" [ngStyle]="{'width': brochureDefined ? '90%' : '100%' }">
                                </file-pond>
                                <fa-icon [icon]="iconX" *ngIf="brochureDefined" class="cr-pointer cl-primary my-auto"
                                (click)="brochureFile = brochureDefined; brochureDefined = undefined"></fa-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3">
                    <button mat-button type="submit" [disabled]="validForm()" (click)="nextStep()">❯</button>
                </div>

            </form>

        </div>
    </div>
</div>